import * as text from './text';

export const capitalizeText = text.capitalizeText;
export const getTruncateDescription = text.getTruncateDescription;
export const slugify = text.slugify;
export const declineWord = text.declineWord;
export const formatPhoneNumber = text.formatPhoneNumber;
export const stripHtmlTags = text.stripHtmlTags;
export const highlightInHtml = text.highlightInHtml;
export const escapeRegExp = text.escapeRegExp;
export const escapeHtml = text.escapeHtml;
export const getTaskTitle = text.getTaskTitle;
export const highlightPlainText = text.highlightPlainText;
